import { render, staticRenderFns } from "./LikeFillSvg.vue?vue&type=template&id=6a8731d6&"
import script from "./LikeFillSvg.vue?vue&type=script&lang=js&"
export * from "./LikeFillSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports